import React from 'react';
import { makeStyles } from '@mui/styles';
import { Tab, Tabs } from '@mui/material';

import AutoPays from './AutoPay';
import CustomerMemberships from './Membership';
import { TabPanel, a11yProps } from '../../../../../../common/utils/TabPanel';
import {
  CONSUMER_PROFILE_TABS,
  useCustomerProfileQueryParams
} from '../../useCustomerProfileQueryParams';

const useStyles: any = makeStyles((theme: any) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    display: 'flex',
    backgroundColor: theme.palette.background.paper
  },
  tabs: {
    width: '200px',
    minWidth: '200px',
    justifyContent: 'flex-start',
    borderRight: `1px solid ${theme.palette.divider}`
  },
  tLeft: {
    '& .MuiTab-wrapper': {
      justifyContent: 'flex-start'
    }
  }
}));

function MembershipTab(props) {
  const classes = useStyles();
  const { customerAllData } = props;
  const [{ subTab }, setQuery] = useCustomerProfileQueryParams();

  const subTabs = CONSUMER_PROFILE_TABS['membership'];
  const currentIndex = Math.max(
    subTabs.findIndex(t => t === subTab),
    0
  );

  const handleChange = (_: unknown, newIndex: number) => {
    setQuery({ tab: 'membership', subTab: subTabs[newIndex] });
  };

  return (
    <div className={classes.root}>
      <Tabs
        value={currentIndex}
        centered={true}
        textColor="primary"
        scrollButtons="auto"
        orientation="vertical"
        onChange={handleChange}
        indicatorColor="primary"
        className={classes.tabs}
      >
        <Tab
          {...a11yProps(0)}
          label="Client Membership"
          className={classes.tLeft}
        />
        <Tab
          {...a11yProps(1)}
          label="Auto Pay History"
          className={classes.tLeft}
        />
      </Tabs>
      <div style={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
        <TabPanel value={currentIndex} index={0}>
          <CustomerMemberships
            key={customerAllData}
            customerAllData={customerAllData}
          />
        </TabPanel>
        <TabPanel value={currentIndex} index={1}>
          <AutoPays customerAllData={customerAllData} />
        </TabPanel>
      </div>
    </div>
  );
}

export default MembershipTab;
